export const FETCH_PROD_BASE_BEGIN = 'FETCH_PROD_BASE_BEGIN'
export const FETCH_PROD_BASE_SUCCESS = 'FETCH_PROD_BASE_SUCCESS'
export const FETCH_PROD_BASE_FAILED = 'FETCH_PROD_BASE_FAILED'
